<template lang="pug">

  v-form(ref="form" v-model="valid" lazy-validation)
    v-card
      v-card-title
        span.headline {{ $tc('user.title', 1) }}
        v-spacer
        v-btn(icon @click="close"): v-icon close
      v-card-text
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(xs4)
              v-text-field(
                v-model="first_name"
                :label="$t('user.first_name')"
                :rules="rules.first_name"
                :error-messages="errors.first_name"
              )
            v-flex(xs4)
              v-text-field(
                v-model="surname"
                :label="$t('user.surname')"
                :rules="rules.surname"
                :error-messages="errors.surname"
              )
            v-flex(xs4)
              v-text-field(
                v-model="name"
                :label="$t('user.name')"
                :rules="rules.name"
                :error-messages="errors.name"
              )
            v-flex(xs12)
              v-text-field(
                v-model="email"
                :label="$t('user.email')"
                :rules="rules.email"
                :error-messages="errors.email"
              )
            v-flex(xs12)
              v-select(
                v-model="department_id"
                :items="departments"
                :label="$tc('department.title', 1)"
                item-text="name"
                item-value="id"
                :rules="rules.department_id"
                :error-messages="errors.department_id"
              )
            v-flex(xs12)
              v-text-field(
                v-model="position"
                :label="$t('user.position')"
                :rules="rules.position"
                :error-messages="errors.position"
              )
      v-card-actions
        v-menu(v-if="data.id" auto)
          template(v-slot:activator="{ on }")
            v-btn(color="red" text v-on="on") {{ $t('ui.delete') }}
          v-list.error
            v-list-item(@click="remove"): v-list-item-title {{ $t('ui.are_you_sure') }}
        v-btn(text @click="close") {{ $t('ui.cancel') }}
        v-spacer
        v-btn(color="blue" text :disabled="!valid" @click="submit") {{ $t('ui.save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default{

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: true,
      name: '',
      first_name: '',
      surname: '',
      email: '',
      department_id: undefined,
      rules: {
        name: [
          // v => !!v || this.$t('validation.required', { field: this.$t('user.name') }),
        ],
        first_name: [
          v => !!v || this.$t('validation.required', { field: this.$t('user.first_name') }),
        ],
        surname: [
          // v => !!v || this.$t('validation.required', { field: this.$t('user.surname') }),
        ],
        email: [
          v => !!v || this.$t('validation.required', { field: this.$t('user.email') }),
        ],
        department_id: [
          v => !!v || this.$t('validation.required', { field: this.$tc('department.title', 1) }),
        ],
        position: [
          v => !!v || this.$t('validation.required', { field: this.$t('user.position') }),
        ],
      },
      errors: {}
    }
  },

  computed: {
    departments() {
      return this.$store.getters['entities/departments/query']().orderBy('name').get()
    },
  },

  watch: {
    name() {
      this.errors.name = undefined
    },
    first_name() {
      this.errors.first_name = undefined
    },
    surname() {
      this.errors.surname = undefined
    },
    email() {
      this.errors.email = undefined
    },
    department_id() {
      this.errors.department_id = undefined
    },
    position() {
      this.errors.position = undefined
    },
  },

  beforeMount() {
    this.name = this.data.name
    this.first_name = this.data.first_name
    this.surname = this.data.surname
    this.email = this.data.email
    this.department_id = this.data.department_id
    this.position = this.data.position
  },

  methods: {
    ...mapActions('entities/users', {
      createItem: 'createItem',
      updateItem: 'updateItem',
      deleteItem: 'deleteItem',
    }),
    close() {
      this.$emit('close')
    },
    submit() {
      if(this.$refs.form.validate()) {
        const data = {
          ...this.data,
          name: this.name,
          first_name: this.first_name,
          surname: this.surname,
          email: this.email,
          department_id: this.department_id,
          position: this.position,
        }
        let promise
        if(this.data.id) promise = this.updateItem(data)
        else             promise = this.createItem(data)
        promise
          .then(response => this.$emit('close'))
          .catch(failed => this.errors = failed.errors || {})
      }
    },
    remove() {
      this.deleteItem(this.data).then(response => this.$emit('close'))
    },
  },
}
</script>